import "./Inventory.css";
import { Link } from "react-router-dom";
import img1 from "../assets/inven.jpeg";
import f1 from "../assets/fe1.jpeg";
import f2 from "../assets/fe2.jpeg";
import f3 from "../assets/fe3.jpeg";
import f4 from "../assets/fe4.jpeg";
import f5 from "../assets/fe5.jpeg";
import f6 from "../assets/fe6.jpeg";

function Inventory() {
    return (
        <section className="inventory-container" id="inventory">
            <div className="inventory-wrapper">

                <h1 className="inventory-title">INVENTORY</h1>
                <p className="inventory-subtitle">
                    Discover a wide range of healthy plants, landscaping solutions,
                    and terrace gardening essentials carefully selected for every
                    gardening enthusiast.
                </p>

                <div className="inventory-top">

                    <div className="inventory-list">

                        <div className="column">
                            <h3>Plant Sales</h3>

                            <ul>
                                <li>Sapling display area</li>
                                <li>Ornamental plant section</li>
                                <li>Flowering plant section</li>
                                <li>Indoor plants</li>
                                <li>Outdoor plants</li>
                                <li>Fruit saplings</li>
                                <li>Shade trees</li>
                                <li>Medicinal plants</li>
                                <li>Herb plants</li>
                            </ul>
                        </div>

                        <div className="divider"></div>

                        <div className="column">
                            <h3>Landscaping</h3>

                            <ul>
                                <li>Landscape design consultation</li>
                                <li>Office landscaping</li>
                                <li>Landscape material display</li>
                                <li>Garden furniture display</li>
                                <li>Water feature display</li>
                                <li>Sample landscape gardens</li>
                                <li>Model garden plots</li>
                                <li>Hardscape materials (pavers, stones, pebbles)</li>
                            </ul>
                        </div>

                        <div className="divider"></div>

                        <div className="column">
                            <h3>Terrace Gardening</h3>

                            <ul>
                                <li>Vegetable seedlings</li>
                                <li>Herb plants</li>
                                <li>Dwarf fruit plants</li>
                                <li>Grow bags</li>
                                <li>Potting mix and soil</li>
                                <li>Compost and fertilizers</li>
                                <li>Drip irrigation kits</li>
                                <li>Vertical gardens systems</li>
                                <li>Gardening tools and accessories</li>
                            </ul>
                        </div>

                    </div>

                    <div className="main-image">
                        <img src={img1} alt="Garden" />
                    </div>

                </div>

                <h2 className="featured-title">Featured Listings</h2>

                <div className="featured-gallery">
                    <img src={f1} alt="Plant 1" />
                    <img src={f2} alt="Plant 2" />
                    <img src={f3} alt="Plant 3" />
                    <img src={f4} alt="Plant 4" />
                    <img src={f5} alt="Plant 5" />
                    <img src={f6} alt="Plant 6" />
                    <img src={f5} alt="Plant 5" />
                    <img src={f6} alt="Plant 6" />
                </div>

                <div className="view-more">
                    <Link to="/plants">
                        <button>View All Plants →</button>
                    </Link>
                </div>
            </div>

        </section>
    );
}

export default Inventory;